import PrimaryPropertiesPanel from "./PrimaryPropertiesPanel";
export default PrimaryPropertiesPanel;
